import React from "react";

import { calculateDateToToday } from "../../../../handlers/utilityFunctions";

const RecommendationsListItem = ({ job, jobOnClick, isSmallScreen }) => {
	const daysSincePosted = calculateDateToToday(job.job.lastUpdatedAt);

	const handleOnClick = () => {
		return jobOnClick(job._id, job.interaction_status);
	};

	return (
		<li
			role="presentation"
			onClick={handleOnClick}
			data-toggle="modal"
			data-target={isSmallScreen ? "#modal-fullscreen-xl" : ""}
		>
			<a
				className={`${job.active ? "active" : ""}`}
				aria-controls="job-1"
				role="tab"
				data-toggle="tab"
				aria-selected="false"
			>
				<div className="row no-gutters">
					<div className="col-2 pr-2">
						<img className="img-fluid company-logo" src="/images/icons/default_company_logo.svg" alt="" />
					</div>

					<div className="col-10">
						<span className="d-flex align-items-center justify-content-between">
							<span style={{ fontSize: "1.2em" }}>{job.job.jobTitle}</span>
						</span>
						<span>{job.job.companyName}</span>
						<br />
						<span className="fa fa-map-marker text-muted mr-1" />
						<span className="">
							{`
                        ${job.job.jobLocation.city},
                        ${job.job.jobLocation.region}
                    `}
						</span>
						<span className="d-flex w-100 fs-12 justify-content-between">
							<span>
								<span className="fa fa-clock text-muted mr-1" />
								<span className="text-muted ">{daysSincePosted}</span>
							</span>
							<span>
								<span className="fa fa-briefcase text-muted mr-1" />
								<span className="text-muted ">{job.job.employmentType}</span>
							</span>
							<span className="text-primary font-weight-bold ml-2">
								Match:
								<span className="bg-primary text-white px-2 rounded-pill ml-1">
									{"fit_score" in job ? ` ${job.fit_score} ` : " N/A "}
								</span>
							</span>
						</span>
					</div>
				</div>
			</a>
		</li>
	);
};

export default RecommendationsListItem;
